const pisRoutes = {
  bindings: {
  },
  templateUrl: '/modules/pis-tool/routes/routes.html',
  controller: 'PISRoutesController',
};

angular
  .module('pis-tool.module')
  .component('pisRoutes', pisRoutes)
  .config(function($stateProvider) {
      $stateProvider.state('pis.workspaces.routes', {
          url: '/routes',
          views: {
              'pisview@pis': 'pisRoutes',
          },
          resolve: {
              // workSpaces: PISService => PISService.getAllWorkspaces(),
          },
      });
  });
